import { FC, memo } from 'react'
import { NodeProps, Position } from '@xyflow/react'
import { useTranslate } from 'react-admin'
import Typography from '@mui/material/Typography'
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep'
import BaseNode from './BaseNode'
import { DataStoreDeleteNodeData } from '../types'
import { xxllncColor } from '../../../layout/theme/color'

const DataStoreDeleteNode: FC<NodeProps> = ({ id, data, selected }) => {
  const translate = useTranslate()
  const nodeData = data as DataStoreDeleteNodeData
  const recordId = (nodeData.recordId ?? '').trim()
  const subtitle = recordId
    ? `${translate('workflow.node.dataStoreDeleteSummary')} · ${recordId.slice(0, 8)}…`
    : translate('workflow.node.dataStoreMissingRecordId')

  return (
    <BaseNode
      // eslint-disable-next-line camelcase
      nodeType="data_store_delete"
      icon={<DeleteSweepIcon fontSize="small" />}
      label={nodeData.label}
      nodeId={id}
      subtitle={subtitle}
      selected={selected}
      handles={[
        { type: 'target', position: Position.Top },
        { type: 'source', position: Position.Bottom },
      ]}
    >
      {!recordId && (
        <Typography
          variant="caption"
          sx={{
            color: xxllncColor.orange100,
            fontWeight: 600,
            display: 'block',
            lineHeight: 1.35,
          }}
        >
          {translate('workflow.node.dataStoreMissingRecordId')}
        </Typography>
      )}
    </BaseNode>
  )
}

export default memo(DataStoreDeleteNode)
